import { render, staticRenderFns } from "./ProjectTile.vue?vue&type=template&id=2a794942&scoped=true&lang=pug&"
import script from "./ProjectTile.vue?vue&type=script&lang=js&"
export * from "./ProjectTile.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTile.vue?vue&type=style&index=0&id=2a794942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a794942",
  null
  
)

export default component.exports